import React from "react";
import { eventConfig } from "@/config/eventConfig";
import "@/components/DataConsentDisclaimer.css";

/**
 * PDPA data-collection consent disclaimer.
 * Displayed directly above every form submission button.
 */
export const DataConsentDisclaimer = ({ className = "", checked = false, onChange, error = false }) => {
  const { intro, purposes, withdrawal } = eventConfig.legal.dataConsentDisclaimer;
  const email = eventConfig.brand.contactEmail;

  // Split the withdrawal sentence so the email renders as a mailto link.
  const [beforeEmail, afterEmail] = withdrawal.split(email);

  return (
    <div className={`data-consent ${className}`} data-testid="data-consent-disclaimer">
      <p className="data-consent__intro">{intro}</p>
      <ul className="data-consent__list">
        {purposes.map((p) => (
          <li key={p}>{p}</li>
        ))}
      </ul>
      <p className="data-consent__withdraw">
        {beforeEmail}
        <a href={`mailto:${email}`}>{email}</a>
        {afterEmail}
      </p>

      <label className={`data-consent__check${error ? " data-consent__check--error" : ""}`}>
        <input
          type="checkbox"
          data-testid="pdpa-consent-checkbox"
          checked={checked}
          onChange={(e) => onChange && onChange(e.target.checked)}
          aria-invalid={error}
          aria-required="true"
        />
        <span>
          I have read and agree to the collection, use and disclosure of my personal data as described above.
          <span className="data-consent__req"> *</span>
        </span>
      </label>
      {error && (
        <p className="data-consent__error" data-testid="pdpa-consent-error">Please tick the box to consent before submitting.</p>
      )}

    </div>
  );
};

export default DataConsentDisclaimer;
